import { DsChart } from './ds-chart.class';
import { ChartOptions } from 'chart.js';
import { DsChartInterface } from '../interfaces/ds-chart.interface';
import { DsChartCustomOptions } from '../interfaces/ds-chart-custom-options.interface';

export class DsHorizontalBarChart extends DsChart {
  /**
   * Creates an instance of DsBarChart.
   *
   * @param language the current language
   * @memberof DsBarChart
   */
  constructor(language = 'en') {
    super(language);
    this.chartType = 'horizontalBar';
  }

  /**
   * Overload of base class function. Init chart for line time chart.
   *
   * @param chart the current chart
   */
  public initChart(chart: DsChartInterface) {
    chart.options = this.getHorizontalBarChartOptions(chart.customOptions);
    super.initChart(chart);
  }

  /**
   * Get horizontal bar chart options.
   *
   * @param customOptions Custom options for the chart
   * @returns ChartOptions
   */
  private getHorizontalBarChartOptions(customOptions: DsChartCustomOptions = {}): ChartOptions {
    const options: ChartOptions = this.getMergedOptions(customOptions);
    const mainColor = customOptions.color || 'white';
    options.scales = {
      xAxes: [
        {
          position: 'top',
          ticks: {
            beginAtZero: true,
            stepSize: customOptions.isPercentage ? 10 : customOptions.xStepSize,
            fontColor: mainColor,
            fontSize: 11,
            max: customOptions.isPercentage ? 100 : undefined,
            maxTicksLimit: customOptions.xMaxTicksLimit ? customOptions.xMaxTicksLimit : 20,
          },
          scaleLabel: {
            display: false,
          },
          gridLines: {
            drawOnChartArea: false,
            offsetGridLines: false,
            color: mainColor,
            zeroLineColor: mainColor,
          },
          stacked: true,
        },
      ],
      yAxes: [
        {
          gridLines: {
            display: false,
          },
          ticks: {
            fontColor: mainColor,
            fontSize: 11,
          },
          stacked: true,
        },
      ],
    };
    return options;
  }
}
